import { useState } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import AnimatedText from "../../Components/AnimatedText";
import {
  Button,
  CustomInput,
  Description,
} from "../../Components/CustomComponents";
import AccountLayout from "../../Components/Layouts/AccountLayout";
import { WEB_ROUTES } from "../../constants";
import { storeToken } from "../../Data/services/localStorageService";
import { useLoginUserMutation } from "../../Data/services/userAuthApi";
import Toast, { SuccessToast } from "../../Hooks/useToast";
import { ACCOUNT_ENUM } from "./Route";

export default function Login({ setPage }) {
  const { handleSubmit, control, register, watch } = useForm();

  const watchEmail = watch("email", "");
  const watchPassword = watch("password", "");

  const navigate = useNavigate();
  // const pagename = useSelector((state) => state.pagename.pagename);

  const [showPassword, setShowPassword] = useState(false);

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleForgotPasswordClick = () => {
    setPage(ACCOUNT_ENUM.FORGOT_PASSWORD);
  };

  const [loginUser, { isLoading }] = useLoginUserMutation();

  const handleLogin = async (data) => {
    data["device_type"] = "web";
    data["device_token"] = "123";
    storeToken("token");
    navigate(WEB_ROUTES.DASHBOARD);
    // return;
    // try {
    //   const response = await loginUser(data);
    //   console.log(response);

    //   if (response.error && !response.data) {
    //     Toast(response.error.data.message, "error");
    //   }
    //   if (!response.error && response.data.code === 200) {
    //     storeToken(response.data.data.api_token);
    //     SuccessToast(response?.data?.message);

    //     navigate(WEB_ROUTES.DASHBOARD);
    //   }
    // } catch (error) {
    //   if (error?.response && error?.response?.data?.message) {
    //     Toast(error?.response?.data?.message, "error");
    //   } else {
    //     Toast("An error occurred during login", "error");
    //   }
    // }
  };

  return (
    <AccountLayout>
      {
        // <Title text="Welcome to" classes="mb-2 fs-4" />
      }

      <AnimatedText text={"Admin Panel"} />

      <Form onSubmit={handleSubmit(handleLogin)}>
        <Controller
          control={control}
          name="email"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                placeholder="Email"
                type="email"
                onChange={onChange}
              />
            </InputGroup>
          )}
        />
        <Controller
          control={control}
          name="password"
          render={({ field: { onChange, onBlur, value, ref } }) => (
            <InputGroup
              className="mb-3"
              style={{
                width: "300px",
              }}
            >
              <CustomInput
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                onChange={onChange}
              />
              <span
                className="input-after-icon mt-1"
                onClick={handleShowPassword}
              >
                {showPassword ? (
                  <FaRegEye color="black" />
                ) : (
                  <FaRegEyeSlash color="grey" />
                )}
              </span>
            </InputGroup>
          )}
        />
        <Button
          text={
            isLoading ? <ClipLoader color="#0f0f0f" size="22px" /> : "Login"
          }
          classes={`mt-3 mb-2 shadow`}
          type="submit"
          disabled={isLoading || !watchEmail || !watchPassword}
          // onClick={handleLogin}
        />
      </Form>
      <Description
        classes="ms-auto cursor-pointer link-text"
        text="Forgot Password ?"
        onClick={handleForgotPasswordClick}
      />
    </AccountLayout>
  );
}
